<template lang="pug">
div.icon-heart(:class="{favorited: isOn, 'not-favorited': isOn === false}" @click="toggleFavorite")
  font-awesome-icon.fa-2x(:style="iconStyle" icon="heart")
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "Heart",
  components: {
    FontAwesomeIcon: FontAwesomeIcon
  },
  props: {
    favorited: {
      type: Boolean,
      required: true
    },
    toggleAction: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  data() {
    library.add(faHeart);
    return {
      isOn: null
    };
  },
  computed: {
    iconStyle() {
      return this.favorited
        ? {
            color: "#e52a6f",
            stroke: "#53433e",
            strokeWidth: "40px"
          }
        : {
            color: "#fbfbfb",
            stroke: "#53433e",
            strokeWidth: "40px"
          };
    }
  },
  methods: {
    toggleFavorite() {
      this.$emit("update:favorited", !this.favorited);
      this.isOn = !this.favorited;
      this.toggleAction();
    }
  }
};
</script>

<style lang="sass" scoped>
.icon-heart
  align-items: center
  display: flex
  height: 4vw
  justify-content: center
  width: 4vw
  -webkit-tap-highlight-color: transparent

  &.favorited path
    animation: bounce-on 0.8s
    transform-origin: 50%

  &.not-favorited path
    animation: bounce-off 0.2s
    transform-origin: 50%

svg
  height: 100%
  width: 100% !important

// ripple animation div
.icon-heart.favorited::before
  animation: ripple 0.8s forwards
  border: 4vw solid #e52a6f99
  border-radius: 8vw
  content: ""
  height: 4vw
  position: absolute
  width: 4vw

// animations
@keyframes bounce-on
  0%
    transform: scale(0)
  30%
    transform: scale(0)
  60%
    transform: scale(1.2, 1.2)
  70%
    transform: scale(1, 1) translate(0%, -10%)
  75%
    transform: scale(1.1, 0.9) translate(0%, 5%)
  80%
    transform: scale(0.95, 1.05) translate(0%, -3%)
  100%
    transform: scale(1.0, 1.0) translate(0%, 0%)

@keyframes bounce-off
  0%
    transform: scale(1.0, 1.0)
  50%
    transform: scale(1.4, 1.4)
  90%
    transform: scale(0.8, 0.8)
  100%
    transform: scale(1.0, 1.0)

@keyframes ripple
  0%
    opacity: 1
    transform: scale(0.01)
  5%
    border: 4vw solid #e52a6f99
  20%
    border: 6vw solid #e52a6f99
  50%
    transform: scale(1.1)
    border: 1px solid #e52a6f99
  50.1%
    border: none
  100%
    transform: scale(1.1)
    border: none
</style>
